import { APP_ROUTES, useAppTranslation } from "@/utils";
import { PhRCalendarBlank, PhRClockClockwise } from "@payping/icons";
import { Menu } from "@payping/web-components";
import { Link, useLocation, useNavigate } from "react-router";
import { ComponentProps } from "react";
import { HOME_INSTALLMENT_FILTER } from "../../Overview/keys";

const Menus = () => {
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  type MenuItem = Required<ComponentProps<typeof Menu>>["items"][number];

  const items: MenuItem[] = [
    {
      key: APP_ROUTES.home.overview.url,
      icon: <PhRCalendarBlank width={20} />,
      label: t("common.installmentsCalender"),

      children: [
        {
          key: `${APP_ROUTES.home.overview.url}?status=${HOME_INSTALLMENT_FILTER.DELAYED}`,
          label: (
            <Link to={`${APP_ROUTES.home.overview.url}?status=${HOME_INSTALLMENT_FILTER.DELAYED}`}>
              {t("common.installmentStatus.delayed")}
            </Link>
          ),
        },
        {
          key: `${APP_ROUTES.home.overview.url}?status=${HOME_INSTALLMENT_FILTER.AHEAD}`,
          label: (
            <Link to={`${APP_ROUTES.home.overview.url}?status=${HOME_INSTALLMENT_FILTER.AHEAD}`}>
              {t("common.installmentStatus.aHead")}
            </Link>
          ),
        },
      ],
    },
    {
      key: APP_ROUTES.home.purchaseHistory.url,
      icon: <PhRCalendarBlank width={20} />,
      label: t("common.installmentPurchases"),
      onClick() {
        navigate(APP_ROUTES.home.purchaseHistory.url);
      },
    },
    {
      key: APP_ROUTES.home.paymentHistory.url,
      icon: <PhRClockClockwise width={20} />,
      label: t("common.paymentHistory"),
      onClick() {
        navigate(APP_ROUTES.home.paymentHistory.url);
      },
    },
  ];

  return (
    <>
      <Menu
        mode="inline"
        className="tw:w-full tw:border-none! tw:py-4!"
        items={items}
        defaultOpenKeys={[location.pathname]}
        selectedKeys={[location.pathname, location.pathname + location.search]}
      />
    </>
  );
};

export default Menus;
